module.exports = __webpack_public_path__ + "static/media/CerdoCuadrada.0f8867ba.jpg";